import ApiService from "../ApiService";

const SchoolService = {
    loadScreenView: (successCallback, failureCallback) => {
        const jsonData = {};
        jsonData.entityType = "network";
        jsonData.entityId = "";

        ApiService.post("/admin/network/schoolselector/initialize", jsonData, successCallback, failureCallback);
    },
    idValueMap: (schoolIdValue, successCallback, failureCallback) => {
        const jsonData = {};
        jsonData.entityType = "network";
        jsonData.entityId = "";

        ApiService.post("/admin/network/schoolselector/idvaluemap?idValue=" + schoolIdValue, jsonData, successCallback, failureCallback);
    },
};

export default SchoolService;
